
import { HomeIcon } from '@heroicons/react/solid'
import { useEffect, useState } from 'react'
import { path } from '../../helpers/routesPath'
import { Link, useLocation } from 'react-router-dom'

const BreadCrumbsGeneric = ({ locations }) => {

    const [loacationes, setLoacationes] = useState([])
    const location = useLocation();
    const [data, setData] = useState("");
    const pathBad = () => {
        const result = path(locations)
        setLoacationes(result)
    }

    useEffect(() => {
        pathBad()
    }, [])
    useEffect(() => {
        setData(location?.state?.data);
    }, [location]);


    return (
        <nav className="flex " aria-label="Breadcrumb">
            <ol role="list" className="bg-white rounded-md shadow px-6 flex space-x-4">
                <li className="flex">
                    <div className="flex items-center">
                        <Link to={'/cuenta/dashboard'} className="text-gray-400 hover:text-gray-500">
                            <HomeIcon className="flex-shrink-0 h-5 w-5" color='#09101f' aria-hidden="true" />
                            <span className="sr-only">Home</span>
                        </Link>
                    </div>
                </li>
                {loacationes?.map((page, index) => (
                    <li key={index} className="flex">
                        <div className="flex items-center">
                            <svg
                                className="flex-shrink-0 w-6 h-full text-gray-200"
                                viewBox="0 0 24 44"
                                preserveAspectRatio="none"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                            >
                                <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                            </svg>
                            <Link
                                state={{ data: data }}
                                to={page?.href}
                                className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                                aria-current={page?.current ? 'page' : undefined}
                            >
                                {page?.name}
                            </Link>
                        </div>
                    </li>
                ))}
            </ol>
        </nav>
    )
}

export default BreadCrumbsGeneric
